import React, { useState } from "react";

import TailwickContactAvatar from "../ChatLayout/TailwickContactAvatar";
import { useBusinessTimezone } from "../../context/BusinessTimezone/BusinessTimezoneContext";
import {
	getStatusMediaLabel,
	getStatusPostedLabel,
} from "../../helpers/statusListPreview";
import { i18n } from "../../translate/i18n";
import { Status } from "./index";

export default function StatusListItem({ ticket, relatedTickets = [] }) {
	const { timeZone: businessTimeZone } = useBusinessTimezone();
	const [viewerOpen, setViewerOpen] = useState(false);

	const items = relatedTickets.length ? relatedTickets : [ticket];
	const contactName = ticket.contact?.name || ticket.contact?.number || "";
	const postedLabel = getStatusPostedLabel(ticket, businessTimeZone);
	const mediaLabel = getStatusMediaLabel(ticket);
	const hasMedia = Boolean(ticket.lastMessageObj?.mediaUrl);

	const toggleViewer = () => setViewerOpen((open) => !open);

	const handleTimeOfStatus = () => {};

	return (
		<>
			<button
				type="button"
				className="tailwick-status-item"
				onClick={toggleViewer}
				disabled={!hasMedia}
				title={
					hasMedia
						? i18n.t("statusList.viewStatus")
						: i18n.t("statusList.unavailable")
				}
			>
				<TailwickContactAvatar
					size="md"
					contactId={ticket?.contact?.id}
					profilePicUrl={ticket?.contact?.profilePicUrl}
					isGroup={Boolean(ticket?.contact?.isGroup)}
					channel={ticket?.channel}
					contactChannel={ticket?.contact?.channel}
					statusHighlight
					syncProfilePic={false}
				/>
				<div className="tailwick-status-item__content min-w-0 flex-1 text-left">
					<h6 className="truncate font-semibold text-default-800">
						{contactName}
					</h6>
					<p className="mt-0.5 truncate text-sm text-default-500">
						{postedLabel || i18n.t("statusList.published")}
					</p>
					<span className="tailwick-status-item__meta mt-1 inline-flex items-center gap-1.5 text-xs font-medium text-primary">
						<span className="tailwick-status-item__dot" aria-hidden />
						{mediaLabel}
						{items.length > 1 ? ` · ${items.length}` : ""}
					</span>
				</div>
				<span className="tailwick-status-item__action shrink-0 text-xs font-semibold text-primary">
					{i18n.t("statusList.viewStatus")}
				</span>
			</button>

			{viewerOpen && hasMedia && (
				<Status
					ticket={ticket}
					relatedTickets={items}
					handleStatus={toggleViewer}
					timeOfStatus={handleTimeOfStatus}
				/>
			)}
		</>
	);
}
